/**
 * Build-time configuration.
 *
 * Vite inlines VITE_* variables into the bundle, so everything here is public
 * by definition. That is fine — client ids and API URLs are not secrets. The
 * prototype also inlined an Azure Functions host key here, which was: anyone
 * who viewed source held full API access. There is no API key any more; the
 * bearer token is issued per user by Entra ID at sign-in.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing build configuration: ${name}. Copy web/.env.example to web/.env.local and fill it in.`
    );
  }
  return value;
}

export const config = {
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL).replace(/\/$/, ''),
  tenantId: required('VITE_ENTRA_TENANT_ID', import.meta.env.VITE_ENTRA_TENANT_ID),
  clientId: required('VITE_ENTRA_CLIENT_ID', import.meta.env.VITE_ENTRA_CLIENT_ID),
  apiScope: required('VITE_ENTRA_API_SCOPE', import.meta.env.VITE_ENTRA_API_SCOPE),
  environmentName: import.meta.env.VITE_ENVIRONMENT_NAME ?? 'unknown',
} as const;

/** Shown as a banner outside production so nobody mistakes dev for the real thing. */
export const isProduction = config.environmentName === 'prod';
